export enum TestRunStatus {
  SCHEDULED = "Scheduled",
  CALCULATION_IN_PROGRESS = "Calculation In Progress",
  FAILED = "Failed",
  CALCULATED = "Calculated"
}
